import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, browserLocalPersistence, setPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

/**
 * Firebase config — apiKey is a PUBLIC identifier per Firebase docs (not a
 * secret). Real security comes from Firebase Auth rules, Firestore Security
 * Rules, and authorized domains. Even so, we read values from env so the
 * source repo isn't tied to a specific Firebase project — copy `.env.example`
 * to `.env.local` and fill in your own project's values.
 *
 * Source: Firebase Console → Project Settings → General → Your apps.
 */
const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(firebaseApp);

// Persist sign-in across reloads (default is "local" anyway, but make it explicit).
// Failures here are non-fatal — auth still works in-memory.
setPersistence(auth, browserLocalPersistence).catch((err) => {
  console.warn("[firebase] persistence setup failed:", err);
});
